export const PER_PAGE = 30;

export const defaultTeamsParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
};

export const defaultUsersParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
};

export const defaultUsersGroupParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
  group_id: 53,
};

export const balancesParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
};

export const ALL_BANKS = 'total balance';

export const balancesFilters = {
  start_date: null,
  end_date: null,
  type: null,
  status: null,
  bank_id: null,
};

export const transactionsParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
};

export const transactionsFilters = {
  start_date: null,
  end_date: null,
  bank_id: null,
  group_id: null,
  order_status: null,
};

export const cardsParams = {
  page: 1,
  per_page: PER_PAGE,
  sort_by: 'created_at',
  sort_dir: 'desc',
};

export const cardsFilters = {
  start_date: null,
  end_date: null,
  bin: null,
  status: null,
  currency: null,
  group_id: null,
  filter: 'actual',
};
